import React, { useState, useEffect } from 'react'
import {
  Table,
  Panel,
  Grid,
  Row,
  Col,
  Icon,
  FlexboxGrid,
  Placeholder,
  IconButton,
  Button,
  Modal,
  Input,
  ControlLabel,
  Message,
} from 'rsuite'
import { useParams, useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import classNames from 'classnames'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, isRequired } from '../../utils/ValidatorUtils'
import {
  updateNotMakeContract,
  getContractPdf,
  getDownloadContractPdf,
  getDownloadContractPdfRealtime,
} from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import pathname from '../../constants/pathname'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'

export default function NotMakeContractPanel(props) {
  const { schema, isStaff, isContractCenter, isDirector, isManager,onSuccess = () => {} } = props
  const [showConfirm, setShowConfirm] = useState(false)
  const [schemas, setSchemas] = useState(schema)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [memo, setMemo] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => {
    if (schema.file.fileName) {
      console.log('filename = ', schema.file.fileName)
      handleGetDownloadContractPdf(schema.file.fileName)
    }
  }, [schema.file.fileName])

  const handleGetDownloadContractPdf = async (fileName) => {
    startLoading()
    setIsLoading(true)
    setIsPdfError(false)
    setIsLoadingPDF(true)
    try {
      const response = await getDownloadContractPdf(projectId, fileName)
      console.log('response preview pdf', response)
      if (response) {
        setPreviewPdf(response)
        setIsPdfError(false)
      }
    } catch (e) {
      try {
        const response = await getDownloadContractPdfRealtime(projectId)

        if (!response.success) {
          setPreviewPdf(response)
          setIsPdfError(false)
        } else {
          setIsPdfError(true)
        }
      } catch (error) {
        setIsPdfError(true)
      }
    }
    setIsLoading(false)
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleCallService = async () => {
    let request = {
      projectVersionId: projectId,
      userId: '',
      value: memo,
    }

    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      let response = await updateNotMakeContract(request, projectId) //ทุก role

      if (response.success) {
        //success jump to new page
        setIsError(false)
        setShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message || response.errorMessage)
      }
      setShowConfirm(false)
    } catch (e) {
      setShowConfirm(false)
      setIsError(
        e?.response?.data?.errors?.Message ||
          e?.response?.data?.errorMessage ||
          schema.buttonText + `ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`
      )
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    setMemo(data.note)
    setShowConfirm(true)
  }

  return (
    <>
      <Panel
        header={schemas.header}
        bordered
        collapsible
        defaultExpanded
        shaded
        style={{ marginBottom: 20 }}
      >
        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
        ) : (
          <PdfRenderWidgets
            file={previewPdf}
            isLoading={isLoadingPDF}
            onReload={() => handleGetDownloadContractPdf(schema.file.fileName)}
          />
        )}

        <br />

        {schema?.note && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <ControlLabel
                className={classNames(isRequired(schema.note.validators) && 'required')}
              >
                {schema.note.label}
              </ControlLabel>
              <ErrorMessage error={errors.note} />
              <Input
                placeholder={schema.note.hint}
                defaultValue={schema.note.value}
                name={schema.note.name}
                componentClass="textarea"
                inputRef={register(isValidators(schema.note.validators))}
              />
            </Col>
          </Row>
        )}

        <hr />

        {isError && (
          <Message
            showIcon
            type="error"
            description={isError || schemas.buttonText + `ไม่สำเร็จ`}
          />
        )}

        {!isStaff && 
          <IconButton
            appearance="ghost"
            className="rs-btn-ghost-cancel"
            icon={<Icon icon="close" className="bt-gost-icon-radius-cancel"></Icon>}
            onClick={handleSubmit(onSubmit)}
            style={{marginBottom: 10}}
          >
            {isContractCenter ? 'บันทึกไม่ทำสัญญา' : schemas.buttonText}
          </IconButton>
        }

        {isStaff && schema?.note ? (
          <>
            <ApproverList 
              approveType={7} 
              projectversionId={projectId} 
              style={{ marginLeft: 10 }} 
              buttontext={'ตรวจสอบสายอนุมัติและ' + schemas.buttonText}
              isLoading={isLoading}
              fetchButton={(disabled) =>
                <IconButton
                  appearance="ghost"
                  className="rs-btn-ghost-cancel"
                  icon={<Icon icon="close" className="bt-gost-icon-radius-cancel"></Icon>}
                  onClick={handleSubmit(onSubmit)}
                  style={{marginBottom: 10}}
                  disabled={disabled}
                >
                  {schemas.buttonText}
                </IconButton>
                }
            />
          </>
        ) : (
          <>
            {schemas?.checkButton && (
              <ApproverList
                approveType={7}
                projectversionId={projectId}
                style={{ marginLeft: 10 }}
                buttontext={schemas?.checkButton}
                isLoading={isLoading}
                fetchButton={(disabled) =>
                  schemas?.fetchButton && (
                    <FetchNewApprover
                      approveType={7}
                      projectversionId={projectId}
                      style={{ marginRight: 10, marginBottom: 10 }}
                      buttontext={schemas?.fetchButton}
                      onSuccess={onSuccess}
                      disabled={disabled}
                    />
                  )
                }
              />
            )}
            {schemas?.cancelButton && (
              <CancelApprovalList
                approveType={7}
                projectversionId={projectId}
                style={{ marginRight: 10, marginLeft: 10 }}
                buttontext={schemas?.cancelButton}
                onSuccess={onSuccess}
              />
            )}
          </>
        )}

        <ConfirmWidget
          size={'sm'}
          title={`ยืนยันการ${schemas.buttonText}`}
          show={showConfirm}
          detail={`ท่านต้องการ${schemas.buttonText}ใช่หรือไม่ ?`}
          onCancle={() => setShowConfirm(false)}
          onConfirm={() => handleCallService()}
        />
      </Panel>
    </>
  )
}
